import styled from 'styled-components';

export const RootContainer = styled.div`
  background: ${({ theme }) => theme.lpbDashboard.colors.bg};
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const FallbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const FallbackMsg = styled.h1`
  font-size: 18px;
  font-weight: 300;
  color: #999;
`;
